export enum InviteRole {
  admin = 1, // -> UserAccountRole.admin
  manager, // -> UserLocationRole.manager
  user, // -> UserLocationRole.user
}
